var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.976,
    height: 15.993,
    viewBox: "0 0 15.976 15.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-10.635 -3.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "translate(10.736 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M26.511,15.794h.107l5.149-1.12a.507.507,0,0,0,.267-.133l8.724-8.724a3.362,3.362,0,0,0,.987-2.4A3.468,3.468,0,0,0,40.757.988,3.361,3.361,0,0,0,38.356,0a3.281,3.281,0,0,0-2.4,1.014l-8.7,8.724a.48.48,0,0,0-.16.24l-1.12,5.149a.587.587,0,0,0,.16.507A.534.534,0,0,0,26.511,15.794ZM38.356,1.068a2.321,2.321,0,0,1,2.321,2.321q0,.013,0,.027a2.241,2.241,0,0,1-.667,1.627L36.729,1.735A2.294,2.294,0,0,1,38.356,1.068ZM35.982,2.508,39.263,5.79l-7.6,7.577-3.281-3.255Zm-8.03,8.67,2.641,2.641-3.388.747Z",
    transform: "translate(-25.97 0)",
    fill: "#38a871",
    stroke: "#38a871",
    strokeWidth: 0.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ee83a424df6069f00da9f5fa77c48e05.svg";
export { ForwardRef as ReactComponent };